import { useTranslation } from 'react-i18next';
import './CtaBanner.css';

interface CtaBannerProps {
  onAction: () => void;
}

export default function CtaBanner({ onAction }: CtaBannerProps) {
  const { t } = useTranslation();

  return (
    <section className="cta-banner">
      <div className="cta-card">
        <div className="cta-content">
          <h2 className="cta-title">{t('home.landing.ctaTitle')}</h2>
          <p className="cta-subtitle">{t('home.landing.ctaSubtitle')}</p>
          <button className="cta-button" onClick={onAction}>
            {t('home.landing.ctaButton')}
          </button>
        </div>
      </div>
    </section>
  );
}
